import { createWebBackApi } from '../../api/webBackApi';

const webBackApi = createWebBackApi();
// Ubicación de la obra: en local (launch.json) se puede apuntar a widget-dev para no escribir en producción.
const obraApi = process.env.REACT_APP_OBRA_API_URL
  ? createWebBackApi({ baseURL: process.env.REACT_APP_OBRA_API_URL })
  : webBackApi;

export const getObras = async (customerId) => {
  try {
    const response = await webBackApi.get('/api/obras', {
      params: customerId ? { customerId } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching obras:', error);
    throw error;
  }
};

export const getObraByFeedID = async (feedID) => {
  try {
    const response = await obraApi.get(`/api/camaras/${feedID}/obra`);
    return response.data;
  } catch (error) {
    // 404 = la cámara todavía no tiene obra/ubicación: es un estado normal (el cliente la marca en el mapa)
    if (error?.response?.status !== 404) console.error('Error fetching obra by feedID:', error);
    throw error;
  }
};

// El cliente ubica su obra en el mapa: guarda ubicacionMaps {lat,lng} (+ direccion) en la obra de la cámara
// (si la cámara no tiene obra, el backend la crea y la vincula). Devuelve la obra actualizada.
export const saveObraUbicacion = async (feedID, { lat, lng, direccion }) => {
  const response = await obraApi.put(`/api/camaras/${feedID}/obra/ubicacion`, { lat, lng, direccion: direccion || undefined });
  return response.data;
};

export const getObraById = async (id) => {
  try {
    const response = await webBackApi.get(`/api/obras/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching obra:', error);
    throw error;
  }
};

export const createObra = async (data) => {
  try {
    const response = await webBackApi.post('/api/obras', data);
    return response.data;
  } catch (error) {
    console.error('Error creating obra:', error);
    throw error;
  }
};

export const updateObra = async (id, data) => {
  try {
    const response = await webBackApi.put(`/api/obras/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating obra:', error);
    throw error;
  }
};

export const deleteObra = async (id) => {
  try {
    const response = await webBackApi.delete(`/api/obras/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting obra:', error);
    throw error;
  }
};
